import { Directive, ElementRef, OnInit } from '@angular/core';
import * as $ from 'jquery';
import '../../../scripts/jquery-ui/jquery-ui.js';

@Directive({
  standalone: false,
  selector: 'input[mas-datepicker-nl]'
})
export class DatepickerNlDirective implements OnInit {

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    const nativeElement: HTMLInputElement = this.el.nativeElement;
    if (!nativeElement) {
      return;
    }

    const that = this;
    $(nativeElement).datepicker({
      showOn: 'button',
      buttonImage: 'assets/images/calendar.png',
      buttonImageOnly: true,
      showButtonPanel: true,
      changeYear: true,
      yearRange: '1900:c+10',
      prevText: '←',
      nextText: '→',
      currentText: 'Vandaag',
      closeText: 'Sluiten',
      monthNames: [
        'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 
        'augustus', 'september', 'oktober', 'november', 'december'],
      monthNamesShort: [
        'jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 
        'aug', 'sep', 'okt', 'nov', 'dec'],
      dayNames: [
        'zondag', 'maandag', 'dinsdag', 'woensdag', 
        'donderdag', 'vrijdag', 'zaterdag'],
      dayNamesShort: [
        'zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
      dayNamesMin: [
        'zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
      firstDay: 1,
      isRTL: false,
      dateFormat: 'dd-mm-yy',
      constrainInput: false
    }).on('change', (e: any) => {
      that.updateValue(e.target.value);
    });
  }

  private updateValue(value: string) {
    const textbox: HTMLInputElement = this.el.nativeElement;
    textbox.value = value;
    let ev: Event;
    try {
        ev = new Event('input');
    }
    catch (ex) {
        // Internet Explorer
        ev = document.createEvent("Event");
        ev.initEvent('input', true, false);
    }
    textbox.dispatchEvent(ev); // todo: use detect changes!
  }
}
